// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Grade_containerPrincipal__-ZXlB","link":"Grade_link__aXWf7"};